import { IBaseResponse } from './base-response.dto';
import { IsNotEmpty, IsString, IsOptional, IsDate } from 'class-validator';
import { ICRMUser } from './crm-user';

export class IScheduleSlot {
  weekDay: number;
  startMinute: number;
  endMinute: number;
}

export class IScheduleOverride {
  id?: string;
  date: Date;
  startMinute: number;
  endMinute: number;
  isAvailable: boolean;
}
export class ISchedule {
  organization: string;
  _id: string;
  label: string;
  slots: IScheduleSlot[];
  startDate: Date;
  /** in minuets, this will override service duration */
  slotDuration?: number;
  endDate: Date;
  extras?: any;
  meta?: any;
  createdAt?: Date;
  updatedAt?: Date;
  overrides: IScheduleOverride[];
  provider?: string | ICRMUser;
  icsLink?: string;
  timezone?: string;
}

export type ScheduleStatus = 'active' | 'disabled';

/* -------------------------------------------------------------------------- */
/*                               Create new Schedule                              */
/* -------------------------------------------------------------------------- */

export class CreateScheduleDto {
  @IsNotEmpty()
  @IsString()
  label: string;

  @IsOptional()
  slots: IScheduleSlot[];

  @IsOptional()
  startDate: Date;

  @IsOptional()
  endDate: Date;

  @IsOptional()
  icsLink: string;

  @IsOptional()
  overrides: IScheduleOverride[];

  extras: any;

  slotDuration?: number;
}

export class CreateScheduleResponse extends IBaseResponse {
  schedule: ISchedule;
}

/* -------------------------------------------------------------------------- */
/*                                   Update Schedule                              */
/* -------------------------------------------------------------------------- */

export class UpdateScheduleDto {
  @IsNotEmpty()
  @IsString()
  status: ScheduleStatus;

  @IsNotEmpty()
  @IsString()
  label: string;

  @IsOptional()
  @IsString()
  description: string;

  @IsOptional()
  slots: IScheduleSlot[];

  @IsOptional()
  @IsDate()
  startDate: Date;

  @IsOptional()
  @IsDate()
  endDate: Date;

  slotDuration?: number;
}

export class UpdateScheduleResponse extends IBaseResponse {
  schedule: ISchedule;
}

/* -------------------------------------------------------------------------- */
/*                                   Add Schedule Slot                          */
/* -------------------------------------------------------------------------- */

export class AddScheduleSlotDto {
  @IsNotEmpty()
  @IsDate()
  startDate: Date;

  @IsNotEmpty()
  @IsDate()
  endDate: Date;
}

export class GetScheduleResponse extends IBaseResponse {
  schedule: ISchedule;
}

/* -------------------------------------------------------------------------- */
/*                                  Get Schedules                                 */
/* -------------------------------------------------------------------------- */
export class GetSchedulesDto {
  label?: string;
  ids?: string;
  startDate?: string | Date | string[] | Date[];
  endDate?: string | Date | string[] | Date[];
}

export type GetSchedulesResponse = ISchedule[];
